export const GRADIENT_POOL = [
  "linear-gradient(135deg, #b3a3ff 0%, #2ec4b6 100%)",
  "linear-gradient(135deg, #ff7a8a 0%, #ffe066 100%)",
  "linear-gradient(135deg, #79c8ff 0%, #b8f0d4 100%)",
  "linear-gradient(135deg, #ff5c8a 0%, #ffb454 100%)",
  "linear-gradient(135deg, #6f7df2 0%, #2ec4b6 100%)",
  "linear-gradient(135deg, #c7f25c 0%, #2ec4b6 100%)",
];

export const pickGradient = (header) => {
  const key = header ?? "";
  let h = 0;
  for (let i = 0; i < key.length; i++) {
    h = (h * 31 + key.charCodeAt(i)) | 0;
  }
  return GRADIENT_POOL[Math.abs(h) % GRADIENT_POOL.length];
};
